import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Brand";
import { FilterEditor, normFilter } from "@/components/FilterEditor";
import { GuestNotice } from "@/components/GuestNotice";
import { Link } from "react-router-dom";

export default function Onboarding() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [draft, setDraft] = useState(() => normFilter(user));
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/me/onboarding", draft);
      setUser(data);
      navigate("/", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen px-5 py-8 sm:py-14">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between gap-3">
          <Logo className="text-2xl" />
          {user.is_guest && (
            <Link to="/login" className="text-sm font-semibold text-primary" data-testid="onboarding-login-link">Have an account? Log in</Link>
          )}
        </div>
        {user.is_guest && <div className="mt-8"><GuestNotice dismissible={false} /></div>}
        <div className="mt-12 mb-10 fade-up">
          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground font-semibold mb-3">Set up your taste</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight" data-testid="onboarding-title">What do you usually watch?</h1>
          <p className="text-muted-foreground mt-3 text-sm sm:text-base">
            Pick what you normally enjoy. This becomes both your Default and your Current mood. Change either any time in Genre preferences.
          </p>
        </div>
        <FilterEditor prefix="onboarding" value={draft} onChange={setDraft} />
        <div className="sticky bottom-0 mt-10 py-4 bg-background/85 backdrop-blur-xl flex items-center justify-between gap-4 border-t">
          <p className="text-sm text-muted-foreground" data-testid="genre-selected-count">{draft.genres.length} genres selected</p>
          <Button onClick={save} disabled={busy} className="rounded-full h-12 px-8 font-bold" data-testid="genre-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Start swiping
          </Button>
        </div>
      </div>
    </div>
  );
}
